// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.element-right {
  text-align: right;
}

.close-button {
  cursor: pointer;
}

.subscribe-title-container {
  display: flex;
}
.subscribe-title-container .col-sm-7 {
  width: 80%;
  display: grid;
}

.dialog-title {
  padding: 10px 20px;
}
.dialog-title h1 {
  font-family: Roboto;
  font-size: 24px;
  letter-spacing: 0.3px;
  line-height: 28px;
  font-weight: 400;
}

.action-btn {
  text-align: right;
  padding: 10px 0 0;
  margin-right: 5px;
}

.subscription-btn {
  text-align: right;
  padding: 0 0 10px 0;
}

.subscription-form-container {
  margin: 0 20px 20px;
}
.subscription-form-container .required-field-title:after {
  content: "*";
  color: var(--forge-theme-error);
  font-size: 12px;
  vertical-align: text-top;
  margin-left: 1px;
}`, "",{"version":3,"sources":["webpack://./src/app/meeting-manager/lib/subscribe-dialog/subscribe-dialog.component.scss"],"names":[],"mappings":"AACA;EACI,iBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;AACI;EACI,UAAA;EACA,aAAA;AACR;;AAGA;EACI,kBAAA;AAAJ;AACI;EACI,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AACR;;AAGA;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;AACI;EACI,YAAA;EACA,+BAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;AACR","sourcesContent":["\n.element-right {\n    text-align: right;\n}\n\n.close-button {\n    cursor: pointer;\n}\n\n.subscribe-title-container {\n    display: flex;\n    .col-sm-7 {\n        width: 80%;\n        display: grid;\n    }\n}\n\n.dialog-title {\n    padding: 10px 20px;\n    h1 {\n        font-family: Roboto;\n        font-size: 24px;\n        letter-spacing: .3px;\n        line-height: 28px;\n        font-weight: 400\n    }\n}\n\n.action-btn { \n    text-align:right; \n    padding:10px 0 0;\n    margin-right: 5px; \n}\n\n.subscription-btn { \n    text-align: right;\n    padding: 0 0 10px 0; \n}\n\n.subscription-form-container{\n    margin: 0 20px 20px;\n    .required-field-title:after {\n        content: \"*\";\n        color: var(--forge-theme-error);\n        font-size: 12px;\n        vertical-align: text-top;\n        margin-left: 1px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
